import React from 'react';
import { Route } from 'react-router-dom';
import { wrapAdmin } from '../routeHelpers';
import * as Pages from '../lazyPages/admin';

export function getAdminRoutes() {
  return (
    <>
      <Route path="/admin" element={wrapAdmin(Pages.AdminDashboard)} />
      <Route path="/admin/capabilities" element={wrapAdmin(Pages.AdminCapabilities)} />
      <Route path="/admin/upload" element={wrapAdmin(Pages.AdminContentHub)} />
      <Route path="/admin/temples" element={wrapAdmin(Pages.AdminContentHub, { defaultTab: 'temples' })} />
      <Route path="/admin/forts" element={wrapAdmin(Pages.AdminContentHub, { defaultTab: 'forts' })} />
      <Route path="/admin/wadas" element={wrapAdmin(Pages.WadaManagement)} />
      <Route path="/admin/historic-information" element={wrapAdmin(Pages.HistoricInformationManagement)} />
      <Route path="/admin/org-categories" element={wrapAdmin(Pages.OrgCategoryManagement)} />
      <Route path="/admin/weapon-categories" element={wrapAdmin(Pages.WeaponCategoryManagement)} />
      <Route path="/admin/fort-trek-guides" element={wrapAdmin(Pages.FortTrekGuideAdmin)} />
      <Route path="/admin/photos" element={wrapAdmin(Pages.PhotoModeration)} />
      <Route path="/admin/users" element={wrapAdmin(Pages.AdminUserManagement)} />
      <Route path="/admin/blogs" element={wrapAdmin(Pages.BlogManagement)} />
      <Route path="/admin/contributions" element={wrapAdmin(Pages.AdminContributions)} />
      <Route path="/admin/visit-bookings" element={wrapAdmin(Pages.AdminVisitBookings)} />
      <Route path="/admin/sardars" element={wrapAdmin(Pages.AdminSardarsManagement)} />
      <Route path="/admin/organizations" element={wrapAdmin(Pages.OrganizationManagement)} />
      <Route path="/admin/thematic-routes" element={wrapAdmin(Pages.AdminThematicRouteManagement)} />
      <Route path="/admin/events" element={wrapAdmin(Pages.AdminEventModeration)} />
      <Route path="/admin/daily-history" element={wrapAdmin(Pages.DailyHistoryManagement)} />
      <Route path="/admin/weapons" element={wrapAdmin(Pages.WeaponManagement)} />
      <Route path="/admin/shop" element={wrapAdmin(Pages.AdminShopManagement)} />
      <Route path="/admin/education" element={wrapAdmin(Pages.AdminEducationManagement)} />
      <Route path="/admin/books" element={wrapAdmin(Pages.AdminBookManagement)} />
      <Route path="/admin/content" element={wrapAdmin(Pages.AdminPlannedFeature, { featureId: 'contentHub' })} />
      <Route path="/admin/site" element={wrapAdmin(Pages.AdminSiteManagement)} />
      <Route path="/admin/media" element={wrapAdmin(Pages.MediaManagement)} />
      <Route path="/admin/analytics" element={wrapAdmin(Pages.AdminAnalytics)} />
      <Route path="/admin/community" element={wrapAdmin(Pages.AdminCommunityManagement)} />
      <Route path="/admin/settings" element={wrapAdmin(Pages.AdminSystemSettings)} />
      <Route path="/admin/review" element={wrapAdmin(Pages.AdminContentReview)} />
      <Route path="/admin/language" element={wrapAdmin(Pages.AdminPlannedFeature, { featureId: 'language' })} />
    </>
  );
}
